















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class MeteorIcon extends Vue {
  @Prop({ type: String, default: '#FFF' }) private trailColor!: string;
  @Prop({ type: String, default: '#179E7E' }) private meteorColor!: string;
  @Prop({ type: String, default: '#FFF' }) private meteorStrokeColor!: string;
}
